import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  padding: 1px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
`;
